import React from 'react';
import PropTypes from 'prop-types';
import { Star } from 'lucide-react';

const ProductInfo = ({ product, className = '' }) => {
  return (
    <div className={`space-y-4 ${className}`}>
      <h1 className="text-3xl font-bold text-gray-900">{product.name}</h1>
      
      {/* Rating */}
      {product.rating && (
        <div className="flex items-center">
          <div className="flex items-center">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star
                key={star}
                className={`h-5 w-5 ${
                  star <= Math.round(product.rating.average)
                    ? 'text-yellow-400 fill-yellow-400'
                    : 'text-gray-300'
                }`}
              />
            ))}
          </div>
          <span className="ml-2 text-sm text-gray-600">
            ({product.rating.count} reviews)
          </span>
        </div>
      )}
      
      {/* Price */}
      <div className="flex items-baseline gap-3">
        <span className="text-2xl font-bold text-gray-900">
          ${product.price.toFixed(2)}
        </span>
        {product.originalPrice > product.price && (
          <span className="text-lg text-gray-500 line-through">
            ${product.originalPrice.toFixed(2)}
          </span>
        )}
        {product.discountPercentage > 0 && (
          <span className="ml-2 text-sm font-medium bg-green-100 text-green-800 px-2 py-0.5 rounded">
            Save {product.discountPercentage}%
          </span>
        )}
      </div>
      
      {/* Stock Status */}
      <div className="text-sm">
        {product.isAvailable ? (
          <span className="text-green-600">
            In Stock ({product.stock} available)
          </span>
        ) : (
          <span className="text-red-600">Out of Stock</span>
        )}
      </div>
      
      {/* SKU */}
      {product.sku && (
        <div className="text-sm text-gray-500">
          SKU: {product.sku}
        </div>
      )}
      
      {/* Category */}
      <div className="text-sm">
        <span className="text-gray-500">Category: </span>
        <span className="font-medium capitalize">{product.category}</span>
      </div>
    </div>
  );
};

ProductInfo.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    rating: PropTypes.shape({
      average: PropTypes.number,
      count: PropTypes.number
    }),
    price: PropTypes.number,
    originalPrice: PropTypes.number,
    discountPercentage: PropTypes.number,
    stock: PropTypes.number,
    isAvailable: PropTypes.bool,
    sku: PropTypes.string,
    category: PropTypes.string
  }).isRequired,
  className: PropTypes.string
};

export default ProductInfo;